import React from "react";
import Typography from "@material-ui/core/Typography";
import cloudStore from "../store/CloudStore";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import { toast, ToastContainer } from "react-toastify";
import { _put } from "../Api";
import AddFloorplanDialog from "../components/AddFloorplanDialog/AddFloorplanDialog";
import RemoveFloorplanDialog from "../components/RemoveFloorplanDialog/RemoveFloorplanDialog";
import AddIcon from "@material-ui/icons/Add";

const defaultFloorplan = "[]";

export default function InHouseFloorplan() {
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const spMerchant = cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);

  const [floorplans, setFloorplans] = React.useState(
    spMerchant.floor_plan == null ? JSON.parse(defaultFloorplan) : JSON.parse(spMerchant.floor_plan)
  );

  const [addDialogState, setAddDialogState] = React.useState(false);
  const [selectedFloorplan, setSelectedFloorplan] = React.useState(null);

  function findCurrentMerchant() {
    return cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);
  }

  if (!spMerchant || !floorplans) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  function changeFloorPlan(index) {
    _put("/nova/sp_merchant/" + spMerchantId + "/floorplan/" + index, {
      name: floorplans[index].name,
    })
      .catch((e) => {
        toast.error("Something went wrong", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFloorplans(JSON.parse(findCurrentMerchant().floor_plan));
        console.log(e);
        return Promise.reject();
      })
      .then((response) => {
        toast.success("Saved successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const sp_merchant = findCurrentMerchant();
        sp_merchant.floor_plan = response.data.floor_plan;
        setFloorplans([...JSON.parse(response.data.floor_plan)]);
      });
  }

  function openAddDialog() {
    setAddDialogState(true);
  }

  function closeAddDialog() {
    setAddDialogState(false);
  }

  function getAddDialogState() {
    return addDialogState;
  }

  function getFloorplans() {
    return floorplans;
  }

  function getSelectedFloorplan() {
    return selectedFloorplan;
  }

  return (
    <div style={{ width: "60%", float: "left" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography variant="h4">Floor plans: {cloudStore.merchant.name}</Typography>
        </div>
        <div>
          <Button variant="contained" color="primary" onClick={openAddDialog} startIcon={<AddIcon />}>
            Floorplan
          </Button>
        </div>
      </div>
      <Divider style={{ marginBottom: "20px" }} />
      <div>
        {floorplans.map((floor, i) => {
          return (
            <Grid key={i} container direction="row" spacing={2}>
              <Grid item lg={6}>
                <Paper style={{ padding: "1em" }} elevation={0} variant="outlined">
                  <TextField
                    label="Name"
                    value={floor.name}
                    onChange={(event) => {
                      floorplans[i].name = event.target.value;
                      setFloorplans([...floorplans]);
                    }}
                    onBlur={(_) => {
                      changeFloorPlan(i);
                    }}
                  />
                </Paper>
              </Grid>
              <Grid item lg={6}>
                <Button>
                  <DeleteIcon
                    onClick={(_) => {
                      setSelectedFloorplan({
                        index: i,
                        floorplan: floorplans[i],
                      });
                    }}
                  >
                    {" "}
                  </DeleteIcon>
                </Button>
              </Grid>
            </Grid>
          );
        })}
      </div>
      <RemoveFloorplanDialog
        key={selectedFloorplan}
        dialogState={getSelectedFloorplan}
        dialogClose={setSelectedFloorplan}
        findMerchant={findCurrentMerchant}
        floorPlans={[getFloorplans, setFloorplans]}
        selectedFloorplan={getSelectedFloorplan}
      />
      <AddFloorplanDialog
        key={addDialogState}
        dialogState={getAddDialogState}
        dialogClose={closeAddDialog}
        findMerchant={findCurrentMerchant}
        floorPlans={[getFloorplans, setFloorplans]}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
